/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MetadataDTO } from './MetadataDTO';
import type { StringValueDTO } from './StringValueDTO';
import type { VariableDTO } from './VariableDTO';

export type TextInputVariableDTO = (VariableDTO & {
    name?: string;
    description?: string;
    metadata?: Array<MetadataDTO>;
    sequence?: number;
    section?: TextInputVariableDTO.section;
    hasUiContract?: boolean;
    alwaysActive?: boolean;
    visibility?: TextInputVariableDTO.visibility;
    value?: StringValueDTO;
    defaultValue?: StringValueDTO;
});

export namespace TextInputVariableDTO {

    export enum section {
        GEOMETRY_SECTION = 'GEOMETRY_SECTION',
        COMPONENT_SECTION = 'COMPONENT_SECTION',
        SURFACE_SECTION = 'SURFACE_SECTION',
        CALCULATION_SECTION = 'CALCULATION_SECTION',
        ADDITIONAL_WORK_SECTION = 'ADDITIONAL_WORK_SECTION',
        QUALITY_SECTION = 'QUALITY_SECTION',
    }

    export enum visibility {
        HIDDEN = 'HIDDEN',
        DISABLED = 'DISABLED',
        VISIBLE = 'VISIBLE',
    }


}
